// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"aPwyr","background-$(backgroundColor)":"bPwyr","searchIconWrapper":"cPwyr"};